const selectAreaHandler =
  ({areas, setArea}) =>
  (areaId) => {
    const area = [...areas].find(({area: areaName}) => areaName === areaId);
    if (!area) return;
    setArea(area);
  };

export default selectAreaHandler;
